import React from 'react';
import { useParams } from 'react-router-dom';
import { H1, Text } from '../components/ui/Typography';
import SafeIcon from '../common/SafeIcon';

const About = () => {
  const { lang = 'nl' } = useParams();
  const isEn = lang === 'en';

  const content = {
    heroTitle: isEn ? 'The logical step before the notary' : 'De logische stap vóór de notaris',
    heroSubtitle: isEn 
      ? 'We are building the modern preparation platform for estate planning. Designed to create clarity, peace of mind, and structure in complex situations.'
      : 'We bouwen het moderne besturingssysteem voor nalatenschapsvoorbereiding. Ontworpen om rust en overzicht te creëren in complexe situaties.',
    mainTitle: isEn 
      ? 'Arranging an estate is traditionally seen as a slow, unclear, and often intimidating process.'
      : 'Het regelen van een nalatenschap is traditioneel gezien een traag, ondoorzichtig en vaak intimiderend proces.',
    para1: isEn 
      ? 'People often postpone estate planning because of perceived costs, complex legal language, or simply not knowing where to begin. Unfortunately, this can lead to unnecessary family conflicts and significant fiscal consequences.'
      : 'Mensen stellen het uit omdat ze opzien tegen de kosten, het juridische taalgebruik, of simpelweg niet weten waar ze moeten beginnen. Dit leidt helaas vaak tot onnodige familieconflicten en hoge fiscale rekeningen.',
    para2: isEn 
      ? 'Testamentair.com was created from the belief that technology can fundamentally improve this process. We provide an intelligent, calm, and secure environment that helps map out your wishes before meeting with a notary.'
      : 'Testamentair.com is ontstaan vanuit de overtuiging dat technologie dit proces fundamenteel kan verbeteren. Wij bieden een intelligente, kalme en veilige omgeving waarin je jouw wensen in kaart brengt.',
    card1Title: isEn ? 'Transparency' : 'Transparantie',
    card1Text: isEn 
      ? 'No hidden complexity. We translate legal concepts into understandable language.'
      : 'Geen verborgen complexiteit. We vertalen juridische concepten naar mensentaal.',
    card2Title: isEn ? 'Security' : 'Veiligheid',
    card2Text: isEn 
      ? 'Your data belongs to you. We apply the highest security standards.'
      : 'Jouw data is van jou. We hanteren de allerhoogste security standaarden.'
  };

  return (
    <div className="max-w-4xl mx-auto px-6 py-20">
      <div className="text-center mb-16">
        <H1 className="mb-6">{content.heroTitle}</H1>
        <Text className="max-w-2xl mx-auto">
          {content.heroSubtitle}
        </Text>
      </div>

      <div className="prose prose-zinc prose-lg mx-auto bg-white p-8 md:p-12 rounded-3xl premium-shadow border border-zinc-100">
        <p className="font-medium text-xl text-zinc-900 mb-6">
          {content.mainTitle}
        </p>
        
        <p className="text-zinc-600 mb-6">
          {content.para1}
        </p>

        <p className="text-zinc-600 mb-8">
          {content.para2}
        </p>

        <div className="grid md:grid-cols-2 gap-8 my-12">
          <div className="bg-zinc-50 p-6 rounded-2xl">
            <SafeIcon name="Eye" className="text-2xl mb-4 text-zinc-900" />
            <h3 className="font-semibold text-zinc-900 mb-2">{content.card1Title}</h3>
            <p className="text-sm text-zinc-600">{content.card1Text}</p>
          </div>
          <div className="bg-zinc-50 p-6 rounded-2xl">
            <SafeIcon name="Shield" className="text-2xl mb-4 text-zinc-900" />
            <h3 className="font-semibold text-zinc-900 mb-2">{content.card2Title}</h3>
            <p className="text-sm text-zinc-600">{content.card2Text}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;